import React, { useMemo } from 'react';
import './App.css';
import 'react-phone-number-input/style.css';
import { Route, Routes } from 'react-router-dom';
import { ConfigProvider, Empty } from 'antd';
import { AuthCheck } from './login/AuthCheck';
import './i18n/i18n'; // English (UK) locale starts week on Monday
import { useTranslation } from 'react-i18next';
import 'dayjs/locale/en-gb'; // Import English (UK) locale for dayjs
import dayjs from 'dayjs';
import GoogleLogin from './login/GoogleLogin';
import { ForgetPassword } from './login/ForgetPassword';
import { ChangePassword } from './login/ChangePassword';
import MainLayout from './components/layout/MainLayout';
import Users from './pages/users/Users';
import ThemeProvider from './providers/ThemeProvider';
import LoginForm from './pages/login/LoginForm';
import { BusinessContextProvider } from './context/BusinessContext';
import { Dashboard } from './pages/dashboard/Dashboard';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { environment } from './environments/environment';
import LoginForm2 from './pages/login/LoginForm2';
import Settings from './pages/settings/Settings';
import NewMainLayout from './components/layout/NewMainLayout';
import CollectionReport from './pages/collection-report/CollectionReport';
import Sites from './pages/sites/Sites';
import MasterDataPage from './pages/master-data/master-data';
import { SuperAdminGuard } from './context/ContractHelpers';
import AdminLayout from './components/layout/AdminLayout';
import Contracts from './pages/admin/Contracts';
import GlobalUsers from './pages/admin/GlobalUsers';
import RolesPermissions from './pages/admin/RolesPermissions';
import CrossContractMasterData from './pages/admin/CrossContractMasterData';
import SelectContract from './pages/select-contract/SelectContract';
import { RequirePermission } from './auth/Can';
import { Permission } from './dto';
import enGB from 'antd/es/locale/en_GB';
dayjs.locale('en-gb');
function App() {
  const { i18n } = useTranslation();
  const { language } = i18n;

  return (
    <ConfigProvider locale={enGB}>
      <GoogleOAuthProvider clientId={environment.googleClientId}>
        <ThemeProvider>
          <Routes>
            <Route path="/login" element={<LoginForm2 />} />
            <Route path="/auth/google" element={<GoogleLogin />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route
              path="/set-password/:email/:token"
              element={<ChangePassword />}
            />
            <Route path="*" element={<AuthCheck />} />
            {/* CR004: post-login hub — picks/auto-enters a contract. */}
            <Route path="/select-contract" element={<SelectContract />} />
            {/* CR004: super-admin shell — cross-contract, no active contract. */}
            <Route
              path="/admin"
              element={
                <SuperAdminGuard>
                  <AdminLayout />
                </SuperAdminGuard>
              }
            >
              <Route index element={<Contracts />} />
              <Route path="projects" element={<Contracts />} />
              <Route path="users" element={<GlobalUsers />} />
              <Route path="roles" element={<RolesPermissions />} />
              <Route path="master-data" element={<CrossContractMasterData />} />
            </Route>
            {/* CR004: operational portal — contract id in the path (shareable). */}
            <Route
              path="/portal/:contractId"
              element={
                <BusinessContextProvider>
                  <NewMainLayout />
                </BusinessContextProvider>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="*" element={<Empty />} />
              <Route path="settings" element={<Settings />} />
              <Route
                path="users"
                element={
                  <RequirePermission
                    any={[
                      Permission.VIEW_USERS,
                      Permission.CREATE_USER,
                      Permission.EDIT_USER,
                      Permission.DELETE_USER,
                    ]}
                  >
                    <Users />
                  </RequirePermission>
                }
              />
              <Route
                path="collection-report"
                element={
                  <RequirePermission
                    any={[
                      Permission.VIEW_REPORTS,
                      Permission.EXPORT_COLLECTION,
                    ]}
                  >
                    <CollectionReport />
                  </RequirePermission>
                }
              />
              <Route
                path="stores"
                element={
                  <RequirePermission
                    any={[
                      Permission.VIEW_SITES,
                      Permission.CREATE_SITE,
                      Permission.EDIT_SITE,
                      Permission.DELETE_SITE,
                    ]}
                  >
                    <Sites />
                  </RequirePermission>
                }
              />
              <Route
                path="sites"
                element={
                  <RequirePermission
                    any={[
                      Permission.VIEW_SITES,
                      Permission.CREATE_SITE,
                      Permission.EDIT_SITE,
                      Permission.DELETE_SITE,
                    ]}
                  >
                    <Sites />
                  </RequirePermission>
                }
              />
              {/*<Route path="master-data" element={<MasterDataPage />} />*/}
              <Route path="master-data">
                <Route
                  path=":type"
                  element={
                    <RequirePermission
                      any={[
                        Permission.VIEW_MASTER_DATA,
                        Permission.CREATE_MASTER_DATA,
                        Permission.EDIT_MASTER_DATA,
                        Permission.DELETE_MASTER_DATA,
                      ]}
                    >
                      <MasterDataPage />
                    </RequirePermission>
                  }
                />
              </Route>

              {/*<Route path="user-group" element={<UserGroupPageX />} />*/}
            </Route>
          </Routes>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </ConfigProvider>
  );
}

export default App;
